import '../../../common/dashboard/filters/applied/applied_multiple_values_filter_view.js.coffee'
import '../../../common/dashboard/filters/users_group_filter_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Applied'

class CustomerVisualMode.Filters.Applied.AppliedUsersGroupFilterView extends
Common.Dashboard.Filters.AppliedMultipleValuesFilterView
  initialize: ({filter, teams, isReadOnly}) ->
    super({filter, isReadOnly})
    _.extend(@, Common.Dashboard.Filters.UsersGroupFilterMixin)
    @teams = teams
    @listenTo(@teams, 'update', @render)

  _seeAll: ->
    @openUsersGroupFilterModal()

  modalTitle: ->
    I18n.t 'common.session.filters.users_group.modal.applied_title'

  modalSubtitle: ->
    I18n.t 'common.session.filters.users_group.modal.applied_subtitle'

  _values: =>
    super.map ({id, name, icon}) =>
      id: id
      name: @teams.get(id)?.get('name') || name
      icon: icon
